import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { FormGroup } from "@angular/forms";

@Component({
    selector: 'mwp-textarea',
    templateUrl: './textarea.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextAreaComponent {
    @Input() public form: FormGroup;
    @Input() public nameForControl: string;
    @Input() public labelName: string;
    @Input() public hideLabel: boolean;
    @Input() public autoTranslate: boolean = true;
    @Input() public height: string;

    constructor(
    ) {
    }
}